<template>
  <g :class="`axis-wrapper ${type}`">
    <g class="axis axis-x" />

    <text
      v-if="showLabel"
      :transform="`translate(${width/2}, 50)`"
      class="label"
    >
      {{ label }}
    </text>
  </g>
</template>

<script>
import d3 from '@/analytics/importers/d3-importer'

const props = {
  scaleX: {},
  showTickText: {
    type: Boolean,
    default: false,
  },
  width: {
    type: Number,
  },
  height: {
    type: Number,
  },
  timeframe: {
    type: String,
    default: null,
  },
  showLabel: {
    type: Boolean,
    default: false,
  },
  type: {
    type: String,
    default: 'line',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
}
// Component for X axis
export default {
  name: 'AxisX',
  props: props,
  data () {
    return {
      labels: {
        this_7_days: 'last 7 days',
        this_30_days: 'last 30 days',
        this_13_weeks: 'last 90 days',
        ytd: 'YTD',
      },
    }
  },
  computed: {
    label () {
      return this.labels[this.timeframe]
    },
  },
  watch: {
    width () {
      this.drawXaxis()
    },
    scaleX () {
      this.drawXaxis()
    },
  },
  mounted () {
    this.drawXaxis()
  },
  methods: {
    drawXaxis () {
      const that = this

      const axisBottom = d3.axisBottom(this.scaleX).tickFormat((d) => d.toString().split('_')[0])

      const g = d3.select(this.$el).select('.axis.axis-x')
          .call(axisBottom)

      g.select('.domain').attr('opacity', '0')
      g.selectAll('.tick text')
          .attr('font-family', 'GT Cinetype Mono, Helvetica, Roboto, Arial, sans-serif')
          .attr('letter-spacing', '1.1px')
          .attr('y', '12')

      if (this.showTickText) {
        g.selectAll('.tick line').attr('opacity', '0')
      } else {
        g.selectAll('.tick text').attr('opacity', '0')
      }

      if (['funnelLabel', 'barchart'].includes(this.type)) {
        g.selectAll('.tick text').attr('color', this.disabled ? '#98a0bc' : '#1f2638')
        g.selectAll('.tick line').attr('opacity', '0')
      } else if (this.type === 'funnelPerc') {
        g.selectAll('.tick text').attr('y', '30')
      } else if (this.type === 'funnelNum') {
        g.selectAll('.tick text').attr('y', '48')
      } else if (['vertGrid', 'vertGridFirst', 'vertGridLast', 'vertGridAll'].includes(this.type)) {
        g.selectAll('.tick line')
            .attr('y2', that.height)
            .attr('stroke', '#e1e4ed')
            .attr('transform', 'rotate(-180)')
            .attr('opacity', '1')

        g.selectAll('.tick:first-of-type line, .tick:last-of-type line')
            .attr('opacity', '0')
      }

      if (this.type === 'vertGridFirst') {
        g.selectAll('.tick:first-of-type line')
            .attr('opacity', '1')
      }

      if (this.type === 'vertGridLast') {
        g.selectAll('.tick:last-of-type line')
            .attr('opacity', '1')
      }

      if (this.type === 'vertGridAll') {
        g.selectAll('.tick:first-of-type line, .tick:last-of-type line')
            .attr('opacity', '1')

        g.selectAll('.tick line')
            .attr('y2', that.height - 24)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
  .axis-wrapper {
    .label {
      text-anchor: middle;
      color: #1f2638;
      text-transform: uppercase;
      font-family: GT Cinetype Mono, Helvetica, Roboto, Arial, sans-serif;
      letter-spacing: 1.1px;
    }
  }
</style>
